import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import TicketCountWidget from '../TicketCountWidget';

class AbstractTooltip {
    constructor(document, useClosingOverall) {
        this.document = document
        this.boxPlacer = new TooltipPlacer()
        this.useClosingOverall = useClosingOverall || false
        this.active = false
    }

    show = (seat) => {
        if(!(seat.name && seat.price)) return
        this.hide()
        this.active = true

        const quadrant = this.boxPlacer.getQuadrant(
            seat.x, seat.y, seat.field_width, seat.field_height)

        this.tooltip = this.document.createElement('div')
        this.tooltip.className = `seatmap-tooltip seatmap-tooltip-${quadrant}`
        this.tooltip.onclick = this.onClick
        this.boxPlacer.configurePosition(
            this.tooltip, seat.x, seat.y, 
            seat.field_width, seat.field_height, quadrant)
        this.document.body.appendChild(this.tooltip)
        if(this.useClosingOverall) setTimeout(
            this.appendClosingOverall, 100)
        this.addContentToTooltip(this.tooltip, seat, this.hide)
    }

    hide = (event) => {
        this.active = false
        if(this.tooltip) {
            this.tooltip.remove()
            delete this.tooltip
        }
        if(this.overall) {
            this.overall.remove()
            delete this.overall
        }
        if(event) {
            event.srcElement.remove()
        }
    }

    appendClosingOverall = () => {
        this.overall = this.document.createElement('div')
        this.overall.className = 'seatmap-overall'
        this.overall.addEventListener("touchstart", this.hide, false)
        this.overall.addEventListener("click", this.hide, false)
        this.document.body.appendChild(this.overall)
    }

    addContentToTooltip()  {
        throw new Error('You should specify `addContentToTooltip` method before')
    }

    isActive = () => {
        return this.active
    }

    onClick = () => {}
}

export class TicketTooltip extends AbstractTooltip {
    addContentToTooltip(domElement, seat) {
        let tooltipText = (
            <div className="seatmap-tooltip-text">
                Цена билета:
                <br />
                {seat.price} руб.
            </div>
        )
        if (seat.row_number && seat.seat_number) {
            tooltipText = (
                <div className="seatmap-tooltip-text">
                    Ряд: {seat.row_number} Место: {seat.seat_number}
                    <br />
                    Цена билета:
                    <br />
                    {seat.price} руб.
                </div>
            )
        }

        ReactDOM.render((
            <>
                <div className="seatmap-tooltip-name">
                    {seat.name}
                </div>
                {tooltipText}
            </>
        ), domElement)
    }
    onClick = () => {this.hide()}
}

export class GASelector extends AbstractTooltip {
    addContentToTooltip(domElement, seat, onClickBack) {
        ReactDOM.render(<GASelectorComponent 
            {...seat} 
            onClickBack={onClickBack} />, domElement)
    }
}

class GASelectorComponent extends Component {
    constructor (props) {
        super(props)
        this.state = {
            max: this.props.max,
            inCart: this.props.inCart,
        }
    }

    render () {
        return (
            <>
                <div className="seatmap-ga-selector">
                    <div className="seatmap-tooltip-name">
                        {this.props.name}
                    </div>
                    <div className="seatmap-tooltip-price">
                        Цена билета:
                        <br />
                        {this.props.price} руб.
                    </div>
                    <TicketCountWidget 
                        id='ga_selector_count'
                        value={this.state.inCart}
                        onChange={this.onChange} 
                        increaseAllowed={this.state.inCart < this.state.max} />
                </div>
            </>
        )
    }

    onChange = (newCount) => {
        this.setState({inCart: newCount})
        this.props.onChange(newCount)
    }
}

class TooltipPlacer {
    constructor() {
        this.x_indent = 10
        this.y_indent = 10
    }

    getQuadrant(x, y, field_w, field_h) {
        const horizontal = x > field_w/2 ? 'right' : 'left'
        const vertical = y < field_h/2 ? 'top' : 'bottom'
        return `${vertical}-${horizontal}`
    }

    configurePosition(element, x, y, field_w, field_h, quadrant) {
        const s = element.style
        s.position = 'absolute'

        if(quadrant.includes('left')) {
            s.left = `${x + this.x_indent}px`
        }
        else if(quadrant.includes('right')){
            s.right = `${field_w - x + this.x_indent}px`
        }

        if(quadrant.includes('top')) {
            s.top = `${y + this.y_indent}px`
        }
        else if(quadrant.includes('bottom')) {
            s.bottom = `${field_h - y + this.y_indent}px`
        }
    }
}
